module.exports = __webpack_public_path__ + "img/coreintercomDesk.7fa557ae.png";